import "./App.css";
import "./axios.js";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import LoginScreen from "./screens/auth/LoginScreen";
import LogoutScreen from "./screens/auth/LogoutScreen.js";
import DashboardScreen from "./screens/dashboard/DashboardScreen.js";
import SettingsScreen from "./screens/settings/SettingsScreen.js";

import UserScreen from "./screens/users/UserScreen.js";
import AddUserScreen from "./screens/users/AddUserScreen.js";
import EditUserScreen from "./screens/users/EditUserScreen.js";
import OrganizerScreen from "./screens/organizers/OrganizerScreen.js";
import AddOrganizerScreen from "./screens/organizers/AddOrganizerScreen.js";
import EditOrganizerScreen from "./screens/organizers/EditOrganizerScreen.js";
import OrderScreen from "./screens/orders/OrderScreen.js";
import OrderDetailScreen from "./screens/orders/OrderDetailScreen.js";
import TicketScreen from "./screens/tickets/TicketScreen.js";
import CategoryScreen from "./screens/category/CategoryScreen.js";
import AddCategoryScreen from "./screens/category/AddCategoryScreen.js";
import EditCategoryScreen from "./screens/category/EditCategoryScreen.js";
import BannerScreen from "./screens/banners/BannerScreen.js";
import AddBannerScreen from "./screens/banners/AddBannerScreen.js";
import EditBannerScreen from "./screens/banners/EditBannerScreen.js";
import StoreScreen from "./screens/stores/StoreScreen.js";
import AddStoreScreen from "./screens/stores/AddStoreScreen.js";
import EditStoreScreen from "./screens/stores/EditStoreScreen.js";
import ClientScreen from "./screens/client/ClientScreen.js";
import DriverScreen from "./screens/drivers/DriverScreen.js";
import AddDriverScreen from "./screens/drivers/AddDriverScreen.js";
import EditDriverScreen from "./screens/drivers/EditDriverScreen.js";
import SectionScreen from "./screens/stores/section/SectionScreen.js";
import ProductScreen from "./screens/stores/product/ProductScreen.js";
import AddProductScreen from "./screens/stores/product/AddProductScreen.js";
import EditProductScreen from "./screens/stores/product/EditProductScreen.js";
import ExtraProductScreen from "./screens/stores/product/extra_items/ExtraProductScreen.js";
import StoreTimeScreen from "./screens/stores/StoreTimeScreen.js";

const router = createBrowserRouter([
  {
    path: "/",
    element: <LoginScreen />,
  },
  {
    path: "/dashboard",
    element: <DashboardScreen />,
  },
  // bannsers
  {
    path: "/banners",
    element: <BannerScreen />,
  },
  {
    path: "/banners/new-banner",
    element: <AddBannerScreen />,
  },
  {
    path: "/banners/edit/:id",
    element: <EditBannerScreen />,
  },
  // stores
  {
    path: "/stores",
    element: <StoreScreen />,
  },
  {
    path: "/stores/new-store",
    element: <AddStoreScreen />,
  },
  {
    path: "/stores/edit/:id",
    element: <EditStoreScreen />,
  },
  {
    path: "/stores/timing/:id",
    element: <StoreTimeScreen />,
  },
  // sections
  {
    path: "/sections",
    element: <SectionScreen />,
  },
  // products
  {
    path: "/products",
    element: <ProductScreen />,
  },
  {
    path: "/products/new-product",
    element: <AddProductScreen />,
  },
  {
    path: "/products/edit/:id",
    element: <EditProductScreen />,
  },
  // extra product
  {
    path: "/products/extras/:id",
    element: <ExtraProductScreen />,
  },
  // clients
  {
    path: "/clients",
    element: <ClientScreen />,
  },
  // drivers
  {
    path: "/drivers",
    element: <DriverScreen />,
  },
  {
    path: "/drivers/new-driver",
    element: <AddDriverScreen />,
  },
  {
    path: "/drivers/edit/:id",
    element: <EditDriverScreen />,
  },

  // users
  {
    path: "/users-space",
    element: <UserScreen />,
  },
  {
    path: "/users-space/new-user",
    element: <AddUserScreen />,
  },
  {
    path: "/users-space/edit/:id",
    element: <EditUserScreen />,
  },
  // organizers
  {
    path: "/organizers",
    element: <OrganizerScreen />,
  },
  {
    path: "/organizers/new-organizer",
    element: <AddOrganizerScreen />,
  },
  {
    path: "/organizers/edit/:id",
    element: <EditOrganizerScreen />,
  },
  // categories
  {
    path: "/categories",
    element: <CategoryScreen />,
  },
  {
    path: "/categories/new-category",
    element: <AddCategoryScreen />,
  },
  {
    path: "/categories/edit/:id",
    element: <EditCategoryScreen />,
  },
  //
  {
    path: "/orders",
    element: <OrderScreen />,
  },
  {
    path: "/orders/detail/:id",
    element: <OrderDetailScreen />,
  },
  //
  {
    path: "/tickets",
    element: <TicketScreen />,
  },

  //
  {
    path: "/settings",
    element: <SettingsScreen />,
  },

  {
    path: "/logout",
    element: <LogoutScreen />,
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
